import { Component, OnInit, ChangeDetectorRef, LOCALE_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NewsService, NewsItem } from '../../services/news.service';
import { CommonModule, registerLocaleData } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import localePt from '@angular/common/locales/pt';

registerLocaleData(localePt);
@Component({
  selector: 'app-read-new',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './read-new.component.html',
  providers: [{ provide: LOCALE_ID, useValue: 'pt' }]
})
export class ReadNewComponent implements OnInit {
  newsItem: NewsItem | null = null; 
  safeContent: SafeHtml | null = null;

  constructor(
    private route: ActivatedRoute,
    private newsService: NewsService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    const id = Number(this.route.snapshot.paramMap.get('id'));
    this.newsService.getById(id).subscribe({
      next: (data) => {
        console.log('Notícia recebida:', data);
        console.log('Content:', data.content);
        console.log('Image URL:', 'https://api.futuroacs.com.br/storage/' + data.image);
        console.log('Created at:', data.created_at);
        console.log('Updated at:', data.updated_at);
        
        this.newsItem = { ...data };
        this.safeContent = this.sanitizer.bypassSecurityTrustHtml(data.content);
        
        // Força a detecção de mudanças
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Erro ao carregar notícia:', err);
      }
    });
  }
}